import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import { IComponentProps, IExtractedProps, ISirenAction, SirenEntity } from "../../../common/utils/commonTypes";

export const ArticleButton: React.FC<IComponentProps> = props => {
    const onClick = label => {
        //Tracking for matomo
        const triggerMatomoEvent: ISirenAction = {
            actionType: "triggerMatomoEvent",
            properties: {
                category: label,
                action: window.location.pathname,
                name: ""
            }
        };
        const dispatch = webui.getDispatchMethod();
        const dispatchAction = webui.getActionByName("siren.dispatchSirenActions");
        const actions: ISirenAction[] = [triggerMatomoEvent, ...((props.data && props.data.actions) || [])];
        dispatch(
            dispatchAction(actions, props.widgetId, props.computedBindTo, ["default", "click"])
        );
    };

    const data: SirenEntity["properties"] = props.data ? props.data.properties || {} : null;

    if (!data) {
        return null;
    }

    const dataProps: IExtractedProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["label", "anchorId"]
    });

    return (
        <div className="un-article-buttons">
            <button
                className="tq-button tq-button-border"
                onClick={() => onClick(dataProps.label)}
                id={dataProps.anchorId ? dataProps.anchorId : null}
            >
                <span className="tq-text-node">{dataProps.label}</span>
            </button>
        </div>
    );
};

export default webui.connectComponent({
    actions: { dispatchSirenActions: "siren.dispatchSirenActions" }
})(ArticleButton);
